import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@chilecompra/react-kit/components'
import { Root } from './CertificateHeaderFolioSection.styles'
/**
 * The Certificate Header Folio's container.
 */
export const CertificateHeaderFolioSection = () => {
  const {
    certificate: { currentDate, completed, failed, folioNumber },
    error,
    loading
  } = useSelector(state => state.enrollmentCertificate)
  return (
    !error &&
    !loading &&
    completed &&
    !failed && (
      <Root>
        <Typography align="right" fontWeight="bold" variant="body1">
          Número de Folio: {folioNumber}
        </Typography>
        <Typography align="right" italic fontWeight="light" variant="body1">
          Fecha de la consulta {currentDate}
        </Typography>
      </Root>
    )
  )
}

export default CertificateHeaderFolioSection
